export default __webpack_public_path__ + "static/3-e2a00273ec0f60c01a75f9c1e20daaa1.png";